export default "__VITE_ASSET__UyRTzxEK__"